<script setup lang="ts">
useDefaultMeta({
  title: 'KA Kredit - Bayar Pengiriman Cepat & Terkendali',
  description:
    'Aktifkan KA Kredit KiriminAja untuk bayar pengiriman paket lebih cepat & efisien. Tanpa approval manual. Anda tetap pantau semua transaksi secara real-time!',
  robots: 'index, follow'
})

const faqs = [
  {
    question: 'Apa itu KA Kredit KiriminAja?',
    answer:
      'Saldo digital prabayar untuk pembayaran pengiriman Non-COD dan ROMS langsung dari dashboard KiriminAja.'
  },
  {
    question: 'Bagaimana cara top-up saldo KA Kredit?',
    answer:
      'Masuk ke <i>Kredit</i> > <i>Beli Kredit</i>, pilih nominal saldo, dan lakukan pembayaran.'
  },
  {
    question: 'Apakah KA Kredit aman digunakan?',
    answer:
      'Ya. Dilengkapi PIN transaksi & OTP WhatsApp sebelum konfirmasi pembayaran.'
  },
  {
    question: 'Siapa yang bisa menggunakan KA Kredit?',
    answer:
      'Member terverifikasi KiriminAja — terutama bisnis dengan tim operasional aktif.'
  },
  {
    question: 'Apakah KA Kredit bisa digunakan untuk Paket COD?',
    answer: 'Tidak. KA Kredit hanya untuk pembayaran Paket Non-COD & ROMS.'
  }
]
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Pembayaran Ekosistem di KiriminAja, Eksekusi Lebih Cepat"
      sub-title="KiriminAja Kredit"
      description="Dengan KA Kredit, bisnis Anda bisa memproses pembayaran paket dan transaksi ROMS secara instan — tanpa menunggu approval manual."
      hero-image="/images/ka-kredit-banner-1.webp"
      button-label="Aktifkan KA Kredit"
      :button-link="
        $utm.utmUrl('/login', {
          redirectTo: '/credit'
        })
      "
    />

    <KeunggulanKaKreditSection1 />
    <KeunggulanKaKreditSection2 />
    <KeunggulanKaKreditSection3 />
    <KeunggulanKaKreditSection4 />
    <KeunggulanKaKreditSection5 />
    <KeunggulanKaKreditSection6 />
    <FaqBase :faqs="faqs" />
    <KeunggulanKaKreditCta />
  </div>
</template>
